import React, { forwardRef } from 'react';
import { HeaderSearchInput } from '@/components/atoms/HeaderSearchInput';
import cx from 'classnames';

interface CurrencySearchInputProperty {
  className?: string;
  onSearch?: (value: string) => void;
  ref?: any;
}

// eslint-disable-next-line react/display-name
const CurrencySearchInput = forwardRef<any, CurrencySearchInputProperty>(({ onSearch, className }, ref) => {
  return (
    <HeaderSearchInput onChange={onSearch} className={cx('max-w-[230px] lg:max-w-[330px]', className)} ref={ref} />
  );
});

export default CurrencySearchInput;
